<div class="coupons-container" id="cupones">
  <div *ngIf="showCouponToast" class="coupon-toast">
    <div class="coupon-toast-content">
      <img class="coupon-toast-icon-left" [src]="'images/ifood-landing/checkmark-circle-verde.svg' | assetsUrl" alt="Ícono de verificación" />
      <span class="coupon-toast-message">Cupom copiado e pronto para usar!</span>
      <img class="coupon-toast-icon-right" [src]="'images/ifood-landing/cross.svg' | assetsUrl" (click)="onCloseToast()" (keydown)="onCloseToastKey($event)" tabindex="0" alt="Cerrar toast" />
    </div>
  </div>
  <div class="coupons-header coupons-title">Cupons exclusivos</div>
  <div class="coupons-subtitle-ifood">Aplique ao selecionar o meio de pagamento</div>
  <!-- Componente Carousel Cuponera -->
  <div class="coupons-carousel" *ngIf="isLoggedIn" (scroll)="onCouponCarouselScroll($event)">
    <div class="coupons-box" *ngFor="let coupon of coupons; let i = index">
      <span class="coupons-circle-deco left"></span>
      <span class="coupons-circle-deco right"></span>
      <div class="coupons-content">
        <div class="coupons-top">
          <div class="coupons-left">
            <div class="coupons-title">{{ coupon.title }}</div>
            <div class="coupons-subtitle">{{ coupon.subtitle }}</div>
          </div>
          <div class="coupons-right">
            <img [src]="'images/ifood-landing/' + coupon.img | assetsUrl" alt="Imagen cupón" class="coupons-img" />
          </div>
        </div>
        <div class="coupons-dotted-line"></div>
        <div class="coupons-bottom">
          <div class="coupons-left">
            <div class="coupons-code">Código: {{ coupon.code }}</div>
            <div class="coupons-expiry">{{ coupon.expiry }}</div>
          </div>
          <div class="coupons-right">
            <button class="coupons-copiar-btn" *ngIf="copiedCoupon !== coupon.code" (click)="onCopyCoupon(coupon.code)">Copiar</button>
            <button class="coupons-usar-agora-btn" *ngIf="copiedCoupon === coupon.code" (click)="onUseNowCoupon(coupon.code)">Usar agora</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Indicador de paginación -->
  <nav *ngIf="isLoggedIn" class="coupons-pagination-indicator" style="display: flex; align-items: flex-start; gap: 8px; margin-top: 8px;">
        <span *ngFor="let coupon of coupons; let i = index"
              [ngStyle]="{
            width: '16px',
            height: '4px',
            borderRadius: '24px',
            background: selectedCouponIndex === i ? 'var(--Brand-Primary-500, #4300D2)' : 'var(--Neutral-300, #DDE1E8)'
          }"
        ></span>
  </nav>
  <button *ngIf="isLoggedIn" class="coupons-ver-todos-btn" (click)="onViewAllCouponsClick()">Ver todos os cupons</button>
  <div *ngIf="!isLoggedIn">
    <div class="coupons-login-box">
      <div class="eva-3-message -warning-secondary">
        <i class="eva-3-icon-warning-filled message-icon"></i>
      </div>
      <div class="coupons-login-content">
        <span class="coupons-login-title">Entre para acessar os cupons</span>
        <span class="coupons-login-subtitle">Você precisa estar logado para acessar este benefício.</span>
        <button class="coupons-login-btn" (click)="onCouponLoginClick()">Fazer login</button>
      </div>
    </div>
  </div>
  <div class="coupons-info-rect" *ngIf="!showCouponsStepsModal" (click)="openCouponsStepsModal()" (keyup.enter)="openCouponsStepsModal()" tabindex="0" style="cursor:pointer;">
    <span class="coupons-info-text">Como usar os cupons</span>
  </div>
</div>
<!-- Modal Como usar os cupons -->
<al-modal
  class="coupons-steps-modal"
  [show]="showCouponsStepsModal"
  [footerDivider]="false"
  [hideClose]="true"
  (closed)="closeModal()"
>
  <div
    slot="content"
    class="cashback-info-modal-content"
    (touchstart)="modalTouchStart($event)"
    (touchmove)="modalTouchMove($event)"
    (touchend)="modalTouchEnd()"
  >
    <div slot="content" class="coupons-steps-content-modal">
      <div class="coupons-modal-title-bar coupons-modal-title-bar--custom"></div>
      <div class="coupons-steps-title">Como usar os cupons</div>
      <div class="coupons-steps-content">
        <div class="coupons-step-vertical">
          <div class="coupons-step-row-1">
            <div class="coupons-step-line-wrap">
              <div class="coupons-step-circle">1</div>
              <div class="coupons-step-dotted-line-1"></div>
            </div>
            <div class="coupons-step1-content">
                <span>
                  Na tela de pagamento, vá até <span class="coupons-step1-bold">”Como você quer pagar?”</span>
                </span>
              <img [src]="'images/ifood-landing/step_1.jpg' | assetsUrl" alt="Step 1" class="coupons-step1-img" />
            </div>
          </div>
          <div class="coupons-step-row-2">
            <div class="coupons-step-line-wrap">
              <div class="coupons-step-circle">2</div>
              <div class="coupons-step-dotted-line-2"></div>
            </div>
            <div class="coupons-step2-content">
              <span class="coupons-step2-normal">Clique em <span class="coupons-step2-bold">“Adicionar”</span></span>
              <img [src]="'images/ifood-landing/step_2.png' | assetsUrl" alt="Step 2" class="coupons-step2-img" />
            </div>
          </div>
          <div class="coupons-step-row-3">
            <div class="coupons-step-line-wrap">
              <div class="coupons-step-circle">3</div>
              <div class="coupons-step-dotted-line-3"></div>
            </div>
            <div class="coupons-step3-content">
              <span class="coupons-step3-text">Informe seu e-mail, o código do cupom e clique em Aplicar.</span>
              <img [src]="'images/ifood-landing/step_3.png' | assetsUrl" alt="Step 3" class="coupons-step3-img" />
            </div>
          </div>
          <div class="coupons-step-row-success">
            <div class="coupons-step-line-wrap">
              <div class="coupons-step-success">
                <img [src]="'images/ifood-landing/checkmark.svg' | assetsUrl" alt="Check" />
              </div>
            </div>
            <div class="coupons-step-success-text">
              Pronto! Seu desconto será aplicado
            </div>
          </div>
        </div>
      </div>
      <button class="coupons-entendi" (click)="closeModal()">Entendi</button>
    </div>
  </div>
</al-modal>
